import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Popover from '@material-ui/core/Popover'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import { MuiThemeProvider } from '@material-ui/core/styles';

import { SideMenu } from './SideMenu'
import { breakPoint, headerMenuHeight, sideMenuWidth, theme } from '../MuiTheme'
import { bgLight, blue, white } from '../Colors'
import { TrIcon } from '../TrIcon'
import {Link} from 'react-router-dom'
import {Intl} from '../Intl'
import {FormattedMessage} from 'react-intl'


function loadTranslations(loadExternalTranslations) {
  return async function(locale)
  {
    const externalTranslations = await loadExternalTranslations( locale )
    const internalTranslations = await import(`../translations/${locale}`)
    return {
      ...internalTranslations,
      ...externalTranslations
    }
  }
}


const Wrap = styled.div`
  height: 100%;
  
  /* padding for fixed position header*/
  padding-top: ${headerMenuHeight}px;
  
  /* padding for side menu */ 
  padding-left: ${sideMenuWidth}px;
  
  /* hide hamburger button */
  #main-layout-open-drawer {
    display: none;
  }

  /* 9007199254740991 is Number.MAX_SAFE_INTEGER value (IE doesn't support Number.MAX_SAFE_INTEGER) */
  @media(max-width: ${p => p.hideSideMenu ? 9007199254740991: breakPoint}px ){
    
    /* when we are smaller than 999px we hide side menu, so remove left padding on main content area */
    padding-left: 0;
    
    /* show hamburger button */
    #main-layout-open-drawer {
      display: inline-flex;
      margin-right: 1.1rem;
      width: 24px;
      height: 24px;
      position: relative;
      bottom: 1px;
      padding: 0;
      svg{
        width: 24px;
        height: 24px;
      }
    }
  }
  
  .tr-menu-buttons {
    svg {
      fill: ${white};
      height: 24px;
      width: 24px;
    }
    button {
      height: 43px !important;
      padding: 8px;
      &:last-of-type {
        margin-right: -5px;
      }
    }
  }
  
  .tr-logo {
    width: 75px;
    height: 35px;
    margin-left: -5px;
    vertical-align: middle;
  }
`
const Content = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${bgLight};
  height: 100%;
  width: 100%;
  flex: 1 1 auto;
  overflow: hidden;
  padding: 1rem 1rem 0 1rem;
  @media(max-width: ${breakPoint}px ){
    padding: 0;
  }
`
const StyledListItem = styled(ListItem)`
  color: ${blue} !important;
  padding: 5px 24px !important;
  a {
    text-decoration: none;
    color: ${blue}
  }
`

export class Layout extends Component
{

  static propTypes = {
    /* Title for side menu, string or a react node */
    title: PropTypes.oneOfType([
      PropTypes.shape({
        messageId: PropTypes.string.isRequired,
        defaultMessage: PropTypes.string.isRequired,
      }),
      PropTypes.node
    ]).isRequired,

    /* Array of objects (See MenuBuilder) or react node for side menu menu items*/
    menu: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.arrayOf(
        PropTypes.shape({
          messageId: PropTypes.string.isRequired,
          defaultMessage: PropTypes.string.isRequired,
          icon: PropTypes.any,
          activeIcon: PropTypes.any,
          onClick: PropTypes.func,
          disableHighlight: PropTypes.bool,
          submenus: PropTypes.arrayOf(PropTypes.object),
          link: PropTypes.string,
          externalLink: PropTypes.shape({
            link: PropTypes.string.isRequired,
            newWindow: PropTypes.bool
          })
        })
      ),
    ]).isRequired,

    /* If an array of items (e.g. MenuBuilder.build()) is passed for 'menu' prop specify which one is active */
    activeMenuItem: PropTypes.any,

    appbarMenus: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        icon: PropTypes.any.isRequired,
        dataTest: PropTypes.string,
        items: PropTypes.arrayOf(
          PropTypes.shape({
            messageId: PropTypes.string.isRequired,
            defaultMessage: PropTypes.string.isRequired,
            link: PropTypes.string,
            externalLink: PropTypes.shape({
              link: PropTypes.string.isRequired,
              newWindow: PropTypes.bool
            }),
            dataTest: PropTypes.string,
            onClick: PropTypes.func
          })
        )
      })
    ),

    /* hide permanent menu that displays when screen is > 999px wide */
    /* when true the layout behaves like screen width is < 999px */
    hideSideMenu: PropTypes.bool,
    showLocaleSwitcher: PropTypes.bool,
    locale: PropTypes.shape({
      id: PropTypes.string,
      locale: PropTypes.string
    }),
    locales: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      locale: PropTypes.string
    })),
    translationLoader: PropTypes.func
  }

  static defaultLocales = [
    {
      id: 'en-US',
      locale: 'English (US)'
    }
  ]

  static defaultProps = {
    hideSideMenu: false,
    locale: Layout.defaultLocales[0],
    locales: Layout.defaultLocales,
    showLocaleSwitcher: true,
    loadingLocale: false,
    translationLoader: () => Promise.resolve({}),
    jest: false
  }

  anchorOrigin = { vertical: 'bottom', horizontal: 'left' }
  transformOrigin = { vertical: 'top', horizontal: 'left' }
  dropdownEls = []
  state = {
    open: false,
  }

  toggle = property => () => {
    this.setState( state => ({ [property]: !state[property] }) )
  }
  close = () => {
    this.toggle('open')()
  }

  onClick = event => {
    const { appbarMenus } = this.props
    const midx = parseInt(event.target.getAttribute('data-midx'))
    const ridx = parseInt(event.target.getAttribute('data-ridx'))
    this.toggle(`appmenu-${midx}`)()
    const item = appbarMenus[midx].items[ridx]
    if(item.onClick) item.onClick(item)
  }

  renderAppbar = () => {
    const { appbarMenus, intl } = this.props
    return (
      <div className="tr-menu-buttons">
        { appbarMenus.map( (menu, idx) => (
          <Fragment key={idx}>
            <IconButton
              buttonRef={node => {this.dropdownEls[idx] = node}}
              onClick={this.toggle(`appmenu-${idx}`)}
              aria-label={menu.label}
              data-test={menu.dataTest}
            >
              {menu.icon}
            </IconButton>
            <Popover
              open={this.state[`appmenu-${idx}`] || false}
              anchorEl={this.dropdownEls[idx]}
              onClose={this.toggle(`appmenu-${idx}`)}
              anchorOrigin={this.anchorOrigin}
              transformOrigin={this.transformOrigin}
            >
              <List data-test={`${menu.dataTest}-dropdown`}>
                { menu.items.map( (item, thisIdx) => {
                  const itemProps = {
                    key : thisIdx,
                    button: true,
                    onClick: this.onClick,
                    'data-test': item.dataTest,
                    'data-midx': idx,
                    'data-ridx': thisIdx
                  }
                  if( item.link )
                  {
                    itemProps.component = Link
                    itemProps.to = item.link
                  }
                  if(item.externalLink)
                  {
                    itemProps.component = 'a'
                    itemProps.href = item.externalLink.link
                    if( item.externalLink.newWindow )
                    {
                      itemProps.target = '_blank'
                    }
                  }

                  return (
                    <StyledListItem {...itemProps} className='appbar-dropdown-item'>
                      <FormattedMessage id={item.messageId} defaultMessage={item.defaultMessage}>
                        { text => <span data-midx={idx} data-ridx={thisIdx}>{text}</span>}
                      </FormattedMessage>
                    </StyledListItem>
                  )}
                )}
              </List>
            </Popover>
          </Fragment>
        ))}
      </div>
    )
  }

  render()
  {
    const {
      title,
      menu,
      activeMenuItem,
      hideSideMenu,
      locale,
      locales,
      showLocaleSwitcher,
      translationLoader,
      jest
    } = this.props

    return (
      <MuiThemeProvider theme={theme}>
        <Intl translationLoader={loadTranslations(translationLoader)} locale={locale} disable={jest}>
          { (locale, onLocaleChange, loadingLocale) => (
            <Wrap hideSideMenu={hideSideMenu}>
              <AppBar >
                <Toolbar className="tr-toolbar">

                  <div>
                    <IconButton
                      color="inherit"
                      aria-label="Open drawer"
                      id="main-layout-open-drawer"
                      onClick={this.toggle('open')}
                    >
                      <MenuIcon />
                    </IconButton>
                    <TrIcon className='tr-logo'/>
                  </div>

                  {this.renderAppbar()}

                </Toolbar>
              </AppBar>

              <SideMenu
                hidePermanent={hideSideMenu}
                open={this.state.open}
                close={this.close}
                title={title}
                menu={menu}
                activeMenuItem={activeMenuItem}
                locale={locale}
                locales={locales}
                showLocaleSwitcher={showLocaleSwitcher}
                onLocaleChange={onLocaleChange}
                loadingLocale={loadingLocale}
              />
              <Content>
                {this.props.children}
              </Content>
            </Wrap>
          )}
        </Intl>
      </MuiThemeProvider>
    )
  }
}


// WEBPACK FOOTER //
// ../../src/Layout/Layout.js